import * as API from '..'
import $const from '../../common/constant'

export default {
  /**
   * 状态接口（用于心跳）
   * @param params
   * @returns {Promise<*>}
   */
  status: params => {
    return API.POST($const.apiServer.Tranning + '/we', params)
  },
  /**
   * 销毁接口
   * @param params
   * @returns {Promise<*>}
   */
  close: params => {
    return API.POST($const.apiServer.Tranning + '/we/close', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/we/api_we.js